import { useRef } from 'react';
import { useApp } from '../../context/AppContext';
import { usePhone } from '../../hooks/usePhone';
import { useI18n } from '../../i18n/useI18n';
import { useUi } from '../../context/UiContext';
import {
  IconCalendar,
  IconChevronLeft,
  IconChevronRight,
  IconChevronsLeft,
  IconChevronsRight,
  IconSearch,
} from '../icons/Icons';
import { CalendarPopover } from '../overlays/CalendarPopover';
import { SearchPopover } from '../overlays/SearchPopover';
import styles from './TopBar.module.css';

function Logo() {
  return (
    <h1 className={styles.logo}>ZIPPAX</h1>
  );
}

export function TopBar() {
  const { actions } = useApp();
  const { t } = useI18n();
  const { ui, toggle } = useUi();
  const phone = usePhone();
  const searchRef = useRef(null);
  const calendarRef = useRef(null);

  return (
    <header className={styles.bar}>
      <div className={styles.cluster} ref={searchRef}>
        <button
          type="button"
          className={styles.iconBtn}
          aria-label={t('nav.search')}
          aria-expanded={ui.searchOpen}
          onClick={() => toggle('searchOpen')}
        >
          <IconSearch />
        </button>
        {ui.searchOpen && <SearchPopover anchorRef={searchRef} />}
      </div>

      <Logo />

      <div className={styles.cluster} ref={calendarRef}>
        {!phone && (
          <button
            type="button"
            className={styles.iconBtn}
            aria-label={t('nav.prevWeek')}
            data-mirror=""
            onClick={() => actions.shiftOffset(-7)}
          >
            <IconChevronsLeft />
          </button>
        )}
        <button
          type="button"
          className={styles.iconBtn}
          aria-label={t('nav.prevDay')}
          data-mirror=""
          onClick={() => actions.shiftOffset(-1)}
        >
          <IconChevronLeft />
        </button>
        <button
          type="button"
          className={styles.iconBtn}
          aria-label={t('nav.nextDay')}
          data-mirror=""
          onClick={() => actions.shiftOffset(1)}
        >
          <IconChevronRight />
        </button>
        {!phone && (
          <button
            type="button"
            className={styles.iconBtn}
            aria-label={t('nav.nextWeek')}
            data-mirror=""
            onClick={() => actions.shiftOffset(7)}
          >
            <IconChevronsRight />
          </button>
        )}
        <button
          type="button"
          className={styles.iconBtn}
          aria-label={t('nav.calendar')}
          aria-expanded={ui.calendarOpen}
          onClick={() => toggle('calendarOpen')}
        >
          <IconCalendar />
        </button>
        {ui.calendarOpen && <CalendarPopover anchorRef={calendarRef} />}
      </div>
    </header>
  );
}
